import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ClassModel } from 'src/app/model/class';

@Component({
  selector: 'app-teacher-class-card',
  templateUrl: './teacher-class-card.component.html',
  styleUrls: ['./teacher-class-card.component.css']
})
export class TeacherClassCardComponent implements OnInit {
  @Input() classData: ClassModel | any;
  @Input() dataType: any;
  @Input() classType: any;
  @Output() actionOnClick = new EventEmitter<any>();

  public isTomorrow: boolean = false;
  public isDropup: boolean = true;
  public isLive: boolean = false;
  public isStatusLive: boolean = false;
  public isToday: boolean = false;
  public eclassWaitingDays: number = 0;

  public cronjob: any = null;

  constructor(
    private _eventHandlingService: EventHandlingService
  ) { }

  ngOnInit(): void {
    // console.log("dataType: ", this.dataType, "classType: ", this.classType, this.classData)
    this.checkStatus();
    this.checkLiveStatus();
  }

  checkStatus = () => {
    if (this.dataType != 'past') {
      this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      // console.log("isToday: ", this.isToday)

      if (this.isToday) {
        this.cronjob = UtilityService.liveClassCounter(this.classData.serverTime, this.classData?.obj?.startTime, this.classData?.obj?.endTime, 'teacher');

        let liveat: any;
        if (this.cronjob?.ediff >= 0) {

          liveat = setTimeout(() => {
            this.isLive = true;
          }, this.cronjob?.sdiff);

          let livetill = setTimeout(() => {
            this.isLive = false;
            // this._eventHandlingService.changeClassStatus('endClass');
            clearTimeout(livetill);
            clearTimeout(liveat);
          }, this.cronjob?.ediff);

        } else if (this.cronjob?.sdiff <= 0 && this.cronjob?.ediff >= 0) {
          this.isLive = true;
        } else if (this.cronjob?.ediff == 0) {
          this.isLive = false;

        }
      } else {
        this.statusCheck();
      }
    }
  }

  checkLiveStatus = () => {
    if (this.dataType != 'past') {
      this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      // console.log("isToday: ", this.isToday)

      if (this.isToday) {
        this.cronjob = UtilityService.liveClassCounter(this.classData.serverTime, this.classData?.obj?.startTime, this.classData?.obj?.endTime);

        let liveat: any;
        if (this.cronjob?.ediff >= 0) {

          liveat = setTimeout(() => {
            this.isStatusLive = true;
          }, this.cronjob?.sdiff);

          let livetill = setTimeout(() => {
            this.isStatusLive = false;
            // this._eventHandlingService.changeClassStatus('endClass');
            clearTimeout(livetill);
            clearTimeout(liveat);
          }, this.cronjob?.ediff);

        } else if (this.cronjob?.sdiff <= 0 && this.cronjob?.ediff >= 0) {
          this.isStatusLive = true;
        } else if (this.cronjob?.ediff == 0) {
          this.isStatusLive = false;

        }
      } else {
        this.statusCheck();
      }
    }
  }

  statusCheck = () => {
    if (!this.isToday) {
      this.isTomorrow = UtilityService.isTomorrow(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      if(!this.isTomorrow) {
        this.eclassWaitingDays = UtilityService.getWaitingDays(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      }
    }
  }

  getClassStatusText():any{
    if(this.dataType != 'past' && this.isStatusLive) {
      return 'NOW LIVE'
    } else if (this.dataType != 'past' && !this.isStatusLive && this.isToday) {
      return 'Starts today'
    } else if (this.dataType != 'past' && this.isTomorrow) {
      return 'Starts tomorrow'
    } else if (this.dataType != 'past' && !this.isTomorrow && this.eclassWaitingDays > 0) {
      return 'Starts in ' + this.eclassWaitingDays + ' days';
    } else if (this.dataType == 'past' && this.classData?.recording?.length > 0) {
      return 'Recorded'
    }
  }

}
